// extracted by mini-css-extract-plugin
module.exports = {"section":"deposit_section__3cD5b","title":"deposit_title__1fTOj","back":"deposit_back__2IHb4","address":"deposit_address__exVK4"};